import React from 'react';
import { SimpleModal, Typography, styled } from '@nextiva/next-ui-components';
import { useSelector, useDispatch } from 'react-redux';
import { useSnackbar } from 'hooks';
import { resetData } from './duck/actions';
import { getStatus } from './duck/selectors';

const StyledTypography = styled(Typography)`
  line-height: 1rem;
`;
const StyledSimpleModal = styled(SimpleModal)`
  color: #333;
  & .MuiTypography-root {
    padding: 16px 0 8px 0;
    text-align: center;
  }
  & .MuiDialogContent-root {
    padding: 0 32px !important;
  }
  & .MuiDialogActions-root {
    padding: 13px 32px 32px 32px !important;
    border-top: none !important;
  }
  & .MuiIconButton-sizeLarge {
    margin-top: -16px;
  }
  & .MuiButton-containedSecondary.MuiButton-containedSizeMedium {
    padding: 0 10px;
    width: 72px;
    height: 32px;
  }
  & .MuiButton-contained.MuiButton-containedDanger {
    padding: 0 10px;
    width: 97px;
    height: 32px;
  }
`;
const StyledTitleTypography = styled(Typography)`
  font-size: 1.25rem;
`;

const ResetData = () => {
  const status = useSelector((state) => getStatus(state));
  const dispatch = useDispatch();
  const setSnackbar = useSnackbar();

  const closePage = (location) => {
    return () => {
      window.location.hash = location || '/reset-data-status';
    };
  };

  const submit = () => {
    return dispatch(resetData(setSnackbar)).then(closePage());
  };

  return (
    <StyledSimpleModal
      onClose={closePage()}
      data-testid="PlatformAdminUI-PurchaseLicenseModal-OpenQuoteModal"
      confirmButtonProps={{
        disabled: status.active,
        color: 'danger',
        onClick: submit,
        'data-testid':
          'PlatformAdminUI-PurchaseLicenseModal-OpenQuoteModalOkButton',
      }}
      cancelButtonProps={{
        onClick: closePage(),
        'data-testid': 'PlatformAdminUI-ResetData-CancelButton',
      }}
      cancelText="Cancel"
      confirmText="Reset Data"
      title={
        <StyledTitleTypography variant="body1">
          Reset Data
        </StyledTitleTypography>
      }
      open
    >
      <StyledTypography variant="body2">
        Are you sure that you want to reset data?
      </StyledTypography>
    </StyledSimpleModal>
  );
};

export default ResetData;
